import { useLenis } from "lenis/react";
import { useCallback } from "react";

export const useScrollTo = () => {
  const lenis = useLenis();
  return useCallback(
    (target) => {
      if (lenis) {
        lenis.scrollTo(target, { offset: -64, duration: 1.5 });
      } else {
        document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
      }
    },
    [lenis]
  );
};
